import React, { ChangeEvent, FormEvent, useEffect, useState } from 'react'
import ErrorIcon from '@mui/icons-material/Error';
import "../constants/forms.css"
import { api_constants } from '../constants/api.constants';
import useFetch from '../hooks/use-fetch.hook';
import { Link, useNavigate } from 'react-router-dom';
import { navigation_constants } from '../constants/navigation.constants';
import { IconType } from 'react-icons';
import { IoInformationCircleOutline } from "react-icons/io5";
import InfoComponent from '../Components/info.component';
import CircularProgress from "@mui/material/CircularProgress";

const JoinBetaPage = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        joinWhatsAppGroupChat: true
    });

    const navigate = useNavigate();

    const { data, isLoading, error, refetch, status } = useFetch<String>({
		endpoint: api_constants.urls.joinBeta,
		method: "POST",
	})

    const [ isBtnEnabled, setIsBtnEnabled ] = useState(false)

    useEffect(()=>{
        console.log(data)
        console.log(status)
        if(status === 201 && data) {
            navigateToSuccess()
        }
    }, [data])

    const navigateToSuccess = () => {
        navigate(navigation_constants.pages.join_beta_success);
    };

    const setJoinWhatsappGroupChat = (newValue: boolean) => {
        setFormData({
            ...formData,
            joinWhatsAppGroupChat: newValue
        })
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value, // Dynamically update state
        });
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        // console.log("Form Submitted:", formData);
        refetch({
            body: {
                email: formData.email,
                phoneNumber: formData.phone,
                fullname: formData.name,
                joinWhatsAppGroupChat: formData.joinWhatsAppGroupChat,
            }
        })
    };

    useEffect(()=> {
        const isEnabled = formData.email.length >= 3 && formData.name.length >= 3 && formData.phone.length >= 7
        setIsBtnEnabled(isEnabled)
    }, [formData])

    const WhatsAppCheckbox = () => {
        return (
            <label
                style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    alignSelf: "flex-start",
                    marginTop: 10,
                    marginLeft: 10
                }}
            >
                {/* Styled Checkbox */}
                <input
                type="checkbox"
                checked={formData.joinWhatsAppGroupChat}
                onChange={()=> {setJoinWhatsappGroupChat(!formData.joinWhatsAppGroupChat)}}
                style={{
                    appearance: "none",
                    width: "20px",
                    height: "20px",
                    borderRadius: "5px",
                    border: "2px solid black",
                    backgroundColor: formData.joinWhatsAppGroupChat ? "black" : "transparent",
                    cursor: "pointer",
                    transition: "background-color 0.3s, transform 0.2s",
                    marginRight: "10px",
                }}
                />
                <span
                style={{
                    fontSize: "16px",
                    color: formData.joinWhatsAppGroupChat ? "black" : "#555",
                }}
                >
                Join WhatsApp Group Chat
                </span>
            </label>

        )
    }

    const Error = () => {
		const color = "#FF6347"
		const messages = Array.isArray(error?.message) ? error?.message : [];
		const Message = ({message}:{message:string}) => (
			<div style={{display: "flex", justifyContent: "center", alignItems: "flex-end", flexDirection: "column"}}>
				<p style={{color: color}} key={message}>{message}</p>
			</div>
		)

		return (
			<div style={{justifyContent: "center", alignItems: "center", flexDirection: "column", alignSelf: "flex-end", marginBottom: "15px"}}>
				{
					Array.isArray(error?.message) ? (
						(messages ?? []).map((message)=>{
							return (
								<Message message={message} />
							)
						})
					) : (
						<Message message={error?.message ?? "Something went wrong"} />
					)
				}
			</div>
		)
	}

    return (
        <div className="container">
            <div className="forms-container">
                <div className="signin-signup">
                <form onSubmit={handleSubmit} action="#" className="sign-in-form">
                    <Link style={{alignSelf: "flex-start", marginBottom: 30}} className="footer-section-child" to={navigation_constants.pages.home}>Back to Homepage</Link>
                    <h2 className="title">Join Android Closed Beta</h2>
                    <div className="input-field">
                        <i className="fas fa-user"></i>
                        <input type="text" name='name' value={formData.name} onChange={handleChange} placeholder="Full Name" />
                    </div>
                    <div className="input-field">
                        <i className="fas fa-user"></i>
                        <input type="email" name='email' value={formData.email} onChange={handleChange} placeholder="Email" />
                    </div>
                    <div className="input-field">
                        <i className="fas fa-lock"></i>
                        <input type="tel" name='phone' value={formData.phone} onChange={handleChange} placeholder="Phone Number" />
                    </div>
                    <WhatsAppCheckbox />

                    <InfoComponent color='grey' InfoIcon={IoInformationCircleOutline} text='Make sure the entered email is the email used to sign in for play store on your android device' />
                    
                    { error && !isLoading ? <Error /> : null }
                    {
                        isLoading ? (
            				<div>
                                <div style={{height:30}} />
                                <CircularProgress style={{color: "grey"}} />
                            </div>
                        ) : (
                            <input disabled={!isBtnEnabled && !isLoading} type='submit' value="Request Access" style={{ width: 200 }} className="btn solid" />
                        )
                    }
                </form>
                </div>
                
            </div>

            <div className="panels-container">
                <div className="panel left-panel">
                    <div className="content">
                        <h3>Request Exclusive Access</h3>
                        <p>
                        Join the closed beta to get exclusive access to new features
                        </p>
                        {/* <button className="btn transparent" id="sign-up-btn">
                        Sign up
                        </button> */}
                    </div>
                    <img src="img/log.svg" className="image" alt="" />
                </div>
                <div className="panel right-panel">
                    <img src="img/register.svg" className="image" alt="" />
                </div>
            </div>
        </div>
    )
}

export default JoinBetaPage